export enum VerifyType {
  register = 'register',
  login = 'login',
}
